import request from "../axios";

const $get = async (url, options = null) => {
    try {
        return await request.get(url, {options});
    } catch (error) {
        return {code: -1, msg: error, data: null, count: 0};
    }
};

const $post = async (url, data, options = null) => {
    try {
        return await request.post(url, data, {options});
    } catch (error) {
        return {code: -1, msg: error, data: null, count: 0};
    }
};

const $upload = async (url, data, progress_callback = null) => {
    try {
        return await request.post(url, data, {
            onUploadProgress: (e) => {
                if (progress_callback) {
                    progress_callback({
                        percent: (e.loaded / e.total * 100).toFixed(0),
                        loaded: e.loaded,
                        total: e.total
                    })
                }
            }
        })
    } catch (error) {
        return {code: -1, msg: error, data: null, count: 0};
    }
}

export {$get, $post, $upload};
